import { FormType } from '../../../form-types';
import { LucenceCardioHemeRISKQuestionFieldAnswers } from './questions';

export const lucenceCardioHemeRisk: FormType<LucenceCardioHemeRISKQuestionFieldAnswers> = {
  name: 'Lucence CardioHemeRISK',
  questions: [
    'lucenceCardioHemeRisk_sexAssignedAtBirth',
    {
      key: 'lucenceCardioHemeRisk_boneMarrowTransplant',
      next: {
        condition: { 'lucenceCardioHemeRisk_boneMarrowTransplant.yes': true },
        key: 'lucenceCardioHemeRisk_ineligible',
        els: 'lucenceCardioHemeRisk_bloodTransfusion14Days'
      }
    },
    'lucenceCardioHemeRisk_bloodTransfusion14Days',
    {
      key: 'lucenceCardioHemeRisk_cancerHistory',
      next: {
        condition: { 'lucenceCardioHemeRisk_cancerHistory.yes': true },
        key: 'lucenceCardioHemeRisk_cancerDetails',
        els: 'lucenceCardioHemeRisk_otherInfoForDoctor'
      }
    },
    'lucenceCardioHemeRisk_cancerDetails',
    'lucenceCardioHemeRisk_otherInfoForDoctor',
    {
      key: 'lucenceCardioHemeRisk_consent',
      next: {
        condition: { 'lucenceCardioHemeRisk_consent.non_consent': true },
        key: 'lucenceCardioHemeRisk_ineligible',
        els: 'lucenceCardioHemeRisk_lucenceContactConsent'
      }
    },
    'lucenceCardioHemeRisk_lucenceContactConsent',
    'lucenceCardioHemeRisk_complete',
    'lucenceCardioHemeRisk_ineligible'
  ]
};

/**
 * Same questionnaire as `lucenceCardioHemeRisk`, plus the cancer-selection page.
 * It reuses the CardioHemeRISK questions rather than duplicating them, so both
 * flows answer into the same `lucenceCardioHemeRisk_*` fields.
 */
export const lucenceInsight: FormType<LucenceCardioHemeRISKQuestionFieldAnswers> = {
  name: 'Lucence INSIGHT',
  questions: [
    'lucenceCardioHemeRisk_sexAssignedAtBirth',
    {
      key: 'lucenceCardioHemeRisk_boneMarrowTransplant',
      next: {
        condition: { 'lucenceCardioHemeRisk_boneMarrowTransplant.yes': true },
        key: 'lucenceCardioHemeRisk_ineligible',
        els: 'lucenceCardioHemeRisk_bloodTransfusion14Days'
      }
    },
    'lucenceCardioHemeRisk_bloodTransfusion14Days',
    {
      key: 'lucenceCardioHemeRisk_cancerHistory',
      next: {
        condition: { 'lucenceCardioHemeRisk_cancerHistory.yes': true },
        key: 'lucenceCardioHemeRisk_cancerDetails',
        els: 'lucenceCardioHemeRisk_otherInfoForDoctor'
      }
    },
    'lucenceCardioHemeRisk_cancerDetails',
    'lucenceCardioHemeRisk_cancerSelection',
    'lucenceCardioHemeRisk_otherInfoForDoctor',
    {
      key: 'lucenceCardioHemeRisk_consent',
      next: {
        condition: { 'lucenceCardioHemeRisk_consent.non_consent': true },
        key: 'lucenceCardioHemeRisk_ineligible',
        els: 'lucenceCardioHemeRisk_lucenceContactConsent'
      }
    },
    'lucenceCardioHemeRisk_lucenceContactConsent',
    'lucenceCardioHemeRisk_complete',
    'lucenceCardioHemeRisk_ineligible'
  ]
};
